import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { AppState } from '../../redux/store/rootReducer';
import { List, Popconfirm, Tooltip } from 'antd';
import { EditOutlined, DeleteOutlined, WarningOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { loadConnTypeConnSizeByTypeID, loadFittingTypes, removeFittingType, updateSts } from './fittingTypeSlice';
import { CommonContext, CommonContextType } from '../../contexts/CommonContext';
import "./fittingType.css";
import { isUserAdmin } from '../../services/authenticationService';

export default function FittingTypeList() {
  const dispatch = useDispatch();
  const { setModelChange, messageApi, setEditUser, list_data, setList, editUser } = React.useContext(CommonContext) as CommonContextType;
  const FittingTypes = useSelector(
    (state: AppState) => state.FittingTypes
  );


  useEffect(() => {
    if (FittingTypes.success.sts == true) {
      if (FittingTypes?.success?.data[0] == 'addBS' || FittingTypes?.success?.data[0] == 'updtBS' || FittingTypes?.success?.data[0] == 'dltBS') {
        dispatch(loadConnTypeConnSizeByTypeID(editUser?.id));

        messageApi.open({
          type: 'success',
          content: FittingTypes.success.data[1],
        });
      }
      else if (FittingTypes?.success?.data[0] == 'addCS' || FittingTypes?.success?.data[0] == 'updtCS' || FittingTypes?.success?.data[0] == 'dltCS') {
        dispatch(loadFittingTypes());

        messageApi.open({
          type: 'success',
          content: FittingTypes.success.data[1],
        });
      } 
       else {
        messageApi.open({
          type: 'success',
          content: FittingTypes.success.data,
        });
      }

      dispatch(updateSts({}));
    } else if (FittingTypes.success.sts == false) {
      messageApi.open({
        type: 'error',
        content: FittingTypes.success.data,
      });

      dispatch(updateSts({}));
    }

  }, [FittingTypes])



  useEffect(() => {
    setList(FittingTypes.FittingType)
  }, [FittingTypes]);

  const showModal = (record?: any) => {
    if (record.id) {
      setEditUser(record)
      setModelChange(true)
    }
  };
  const handleDelete = (id: number) => {
    dispatch(removeFittingType(id));
  };





  return (
    <List
      className="demo-loadmore-list"
      itemLayout="horizontal"
      dataSource={FittingTypes.FittingType}
      renderItem={(item: any, index) => (
        <List.Item key={item.id}
          actions={isUserAdmin() ?
            [<EditOutlined style={{ color: '#018B98' }} onClick={() => showModal(item)} />,
            <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(item.id)}>
              <DeleteOutlined style={{ color: 'red' }} />
            </Popconfirm>] : []}>


          <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
            <img width={70} alt="shape" src={process.env.REACT_APP_AZURE_BLOB_STORAGE_API + item?.conn_type_img_url} />
            <div style={{ marginLeft: '40px', width: '40%' }}><b>ID:</b> {index + 1} <br /> <b>Order:</b> {item?.order} <br /> <b>Code:</b> {item.type_code} <br /> <b>Name:</b> {item.type_name}</div>
            <p className='sub_data' style={{ width: '20%' }}><b>Default:</b> {JSON.stringify(item.default_sts)}</p>
            <p className='sub_data' style={{ width: '20%' }}>{(item?.con_type_con_size?.length != 0) ? '' : <Tooltip placement="top" title="It does not have any connection size" color="red"> <WarningOutlined style={{ color: 'red', fontSize: '200%' }} /></Tooltip>} </p>
          </div>

        </List.Item>
      )}
    />
  );
}